/**
 * Physical Therapy Re-evaluation Note — options + empty payload.
 * After shared common header: Re-eval Info → Changes → Assessment table →
 * Goals → Skilled Need → Plan of Care → Discharge (per screenshots).
 * No wound section. Pattern matches PT Visit Note.
 */

import { emptyPtNotesCommonHeader } from "./ptNotesCommonHeaderUtils";
import {
  emptyProgressGoalRow,
  emptyProgressGoals,
} from "./ptGoals";

export const REEVAL_REASON_OPTIONS = [
  "Routine (Per Plan of Care)",
  "Change in Condition",
  "Post Hospitalization",
  "Post ER Visit",
  "Fall",
  "Other",
];

export const CHANGES_SINCE_LAST_OPTIONS = [
  "New Diagnosis",
  "Hospitalization",
  "ER Visit",
  "Change in Medication",
  "Change in Functional Status",
  "New Fall / Near Fall",
  "Change in Assistive Device",
  "Change in Home Environment",
  "Caregiver Change",
  "Other Significant Change",
];

export const ASSESSMENT_AREA_OPTIONS = [
  "Pain (0-10)",
  "Range of Motion (AROM/PROM)",
  "Strength (MMT)",
  "Bed Mobility",
  "Transfers (Type/Assist Level)",
  "Ambulation (Distance)",
  "Ambulation (Assistive Device)",
  "Gait Quality",
  "Balance (Static / Dynamic)",
  "Balance Score (e.g., Tinetti/Berg)",
  "Endurance / Activity Tolerance",
  "Stairs",
  "Functional Outcome Score",
  "Other",
];

export const CHANGE_OPTIONS = ["Improved", "Declined", "No Change"];

export const GOAL_STATUS_OPTIONS = ["Met", "Partially Met", "Not Met"];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const PLAN_OF_CARE_STATUS_OPTIONS = [
  "Continue Without Changes",
  "Modify Plan of Care",
  "Decrease Frequency",
  "Increase Frequency",
  "New Physician Orders Requested",
  "Discharge Planning Initiated",
];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

export const emptyAssessmentRow = (area) => ({
  area,
  lastAssessment: "",
  currentAssessment: "",
  change: "",
});

export { emptyProgressGoalRow as emptyGoalRow, emptyProgressGoals as emptyGoals };

export const emptyAssessmentFindings = () =>
  ASSESSMENT_AREA_OPTIONS.map((area) => emptyAssessmentRow(area));

/** Full editable PT Re-evaluation Note payload (JSON on dedicated row). */
export const emptyPtReevalNotePayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  visitDate: "",
  commonHeader: emptyPtNotesCommonHeader(),

  // —— 7. Re-evaluation Information ——
  reevalReasons: [],
  reevalReasonOther: "",

  // —— 8. Changes Since Last Assessment ——
  changesSinceLast: [],
  changesComments: "",

  // —— 9. Current PT Assessment (vs last) ——
  assessmentFindings: emptyAssessmentFindings(),

  // —— 10. Progress Toward Goals (dynamic +Add Goal) ——
  goals: emptyProgressGoals(3),
  additionalGoalsAttached: false,

  // —— 11. Skilled PT Need ——
  skilledPtNeed: "",

  // —— 12. Plan of Care / Orders ——
  planOfCareStatus: [],
  planOfCareComments: "",

  // —— 13. Discharge Planning ——
  dischargeAnticipated: "",
  dischargeExpectedDate: "",
  dischargeNeedsPlan: "",

  // —— Signature extras ——
  patientRelationship: "",
});

export const PT_REEVAL_ARRAY_KEYS = [
  "reevalReasons",
  "changesSinceLast",
  "planOfCareStatus",
];
